<input
  type="file"
  #fileInput
  (change)="selecionaArquivo($event)"
  class="visually-hidden"
  [accept]="accept"
  [disabled]="disabled" />

<mat-form-field appearance="outline" fxFlex>
  <mat-label>{{ label }}</mat-label>
  <mat-spinner matPrefix diameter="20" *ngIf="fc.value.downloading"></mat-spinner>
  <mat-icon
    matPrefix
    (click)="download()"
    *ngIf="!fc.value.downloading && (fc.value.status === 4 || fc.value.status === 3 || fc.value.status === 2)"
    >download</mat-icon
  >
  <input matInput [formControl]="fc" readonly />
  <mat-icon matSuffix [ngClass]="{ disabledIcon: disabled || fc.value.downloading }" (click)="fileSelectorClick()">
    {{ fc.value.status !== 0 ? 'refresh' : 'folder_open' }}
  </mat-icon>
  <mat-hint>
    <span *ngIf="fc.value.downloading && fc.value.downloadProgress !== undefined">
      Download: {{ fc.value.downloadProgress }}% concluído
    </span>
    <span *ngIf="!fc.value.downloading">{{
      fc.value.status === 0
        ? tip
        : fc.value.size > 0
        ? 'Tamanho do arquivo: ' + (fc.value.size / (1024 * 1024) | number : '1.2-2') + ' MB'
        : ''
    }}</span>
  </mat-hint>
</mat-form-field>
